export default __webpack_public_path__ + "static/media/art_studio_1k.020c0319.hdr";